import VoteBlock from '../components/VoteBlock';

export default function VotePage() {
  return (
    <div className='page'>
      <VoteBlock />
    </div>
  );
}
